module.exports = __webpack_public_path__ + "public/img/Pelayanan Prima untuk Customer Service Online.d96888cf.png";